import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { formatCurrency } from 'v3/utils/formatter';
import Text from 'v3/components/Text';
import { useFreightValues } from '../../context';

export default function HeaderShow() {
  const { data, erpExchangeValue } = useFreightValues();
  return (
    <>
      <Row className="my-2">
        <Col md={2} xs={12}>
          <Text type="label" color="#464E5F">
            Moeda
          </Text>
          <Text id="label-moeda" type="regular" color="gray" as="p" className="mt-1">
            {formatCurrency(data?.freightExchange, 'USD', 'R$')}
          </Text>
        </Col>
        <Col md={2} xs={12}>
          <Text type="label" color="#464E5F">
            Moeda (venda)
          </Text>
          <Text id="label-moeda" type="regular" color="gray" as="p" className="mt-1">
            {formatCurrency(erpExchangeValue, 'USD', 'R$')}
          </Text>
        </Col>
        <Col md={2} xs={12}>
          <Text type="label" color="#464E5F">
            Moeda do dia
          </Text>
          <Text id="label-moeda-dia" type="regular" color="gray" as="p" className="mt-1">
            {formatCurrency(data?.exchangeDay, 'USD', 'R$')}
          </Text>
        </Col>

        <Col xs={12} md={2}>
          <Text type="label" color="#464E5F">
            Câmbio
          </Text>
          <Text id="label-cambio" type="regular" color="gray" as="p" className="mt-1">
            {data?.currency?.value === 'BRL' ? 'Real' : 'Dólar'}
          </Text>
        </Col>
        <Col sm={12} md={2}>
          <Text type="label" color="#464E5F">
            Tipo valor carga
          </Text>
          <Text id="label-calculo-valor-carga" type="regular" color="gray" as="p" className="mt-1">
            {data?.loadValueType?.value || 'Não informado'}
          </Text>
        </Col>
        <Col sm={12} md={2}>
          <Text type="label" color="#464E5F">
            Negociação
          </Text>
          <Text id="label-negociacao" type="regular" color="gray" as="p" className="mt-1">
            {data?.negotiationType?.value || 'Não informado'}
          </Text>
        </Col>
      </Row>
    </>
  );
}
